import { api } from './api';
import type {
  ConnectionType, ConnectionTypeCreateRequest, ConnectionTypeUpdateRequest,
  PaginatedResponse, QueryParams,
} from '../types/partners';

export const connectionTypesService = {
  getAll: async (params?: QueryParams): Promise<PaginatedResponse<ConnectionType>> => {
    const res = await api.get<PaginatedResponse<ConnectionType>>('/api/v1/connection-types/list', { params });
    return res.data;
  },
  getAllForDropdown: async (): Promise<ConnectionType[]> => {
    const res = await api.get<PaginatedResponse<ConnectionType>>('/api/v1/connection-types/list', {
      params: { page: 1, page_size: 500, include_deleted: false },
    });
    return res.data.data || [];
  },
  getById: async (id: string): Promise<ConnectionType> => {
    const res = await api.get<{ data: ConnectionType }>(`/api/v1/connection-types/get/${id}`);
    return res.data.data;
  },
  create: async (data: ConnectionTypeCreateRequest) => (await api.post('/api/v1/connection-types/create', data)).data,
  update: async (id: string, data: ConnectionTypeUpdateRequest) => (await api.put(`/api/v1/connection-types/update/${id}`, data)).data,
  delete: async (id: string) => (await api.delete(`/api/v1/connection-types/delete/${id}`)).data,
  restore: async (id: string) => (await api.patch(`/api/v1/connection-types/restore/${id}`)).data,
};
